import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import {
  Button,
  ButtonToolbar,
  Content,
  FlexboxGrid,
  Form,
  Notification,
  Panel,
  toaster,
} from "rsuite";
import { isLoggedErp } from "../../Atoms/auth.erp.atom";
import { AuthErpService } from "../../Api/authErp.service";
import Translation from "../../translation/translation";

const LoginErp = ({ closeModal }) => {
  const setLogged = useSetRecoilState(isLoggedErp);
  const [model, setmodel] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const authenticate = () => {
    if (model.username && model.password) {
      AuthErpService()
        .login(model)
        .then((res) => {
          localStorage.setItem("erp-token", res.data.access_token);
          setLogged(true);
          closeModal();
          toaster.push(
            <Notification
              type="success"
              header={Translation.successHeader}
              closable
            >
              {Translation.success}
            </Notification>,
            { placement: "topEnd" }
          );
        })
        .catch((error) => {
          toaster.push(
            <Notification
              type="error"
              header={Translation.errorHeader}
              closable
            >
              {error?.response?.data?.title ||
                error?.response?.data?.message ||
                Translation.error}
            </Notification>,
            { placement: "topEnd" }
          );
        });
    }
  };

  return (
    <div>
      <Content>
        <FlexboxGrid justify="center">
          <FlexboxGrid.Item colspan={12}>
            <Panel
              style={{ background: "#fff" }}
              header={<h3>Connexion</h3>}
              bordered
            >
              <Form fluid>
                <Form.Group>
                  <Form.ControlLabel>
                    Nom d'utilisateur ou email:
                  </Form.ControlLabel>
                  <Form.Control
                    name="username"
                    onChange={(username) => {
                      setmodel((prev) => {
                        return { ...prev, username };
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel>Mot de passe :</Form.ControlLabel>
                  <Form.Control
                    name="password"
                    type="password"
                    onChange={(password) => {
                      setmodel((prev) => {
                        return { ...prev, password };
                      });
                    }}
                    autoComplete="off"
                  />
                </Form.Group>
                <br></br>
                <Form.Group style={{ textAlign: "right" }}>
                  <ButtonToolbar>
                    <Button
                      appearance="primary"
                      color="green"
                      onClick={authenticate}
                    >
                      Connexion
                    </Button>
                  </ButtonToolbar>
                </Form.Group>
              </Form>
            </Panel>
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Content>
    </div>
  );
};

export default LoginErp;
